import { useRecordContext } from "react-admin";

export const GenericOptionRenderer = () => {
    const record = useRecordContext();
    return (
        <span>
            {record.name}
        </span>
    );
};

export const CommunityOptionRenderer = () => {
    const record = useRecordContext();
    return (
        <span>
            {record.city ? `${record.city}, ${record.state}` : record.state}
            {/* {record.city}, {record.state} */}
            <br/>
            <small>{record.name}</small>
        </span>
    );
};


export const UserOptionRenderer = () => {
    const record = useRecordContext();
    return (
        <span>
            {record.name}
            <br/>
            <small>{record.email}</small>
        </span>
    );
    //
};
